import { render, staticRenderFns } from "./MobileFullScreenContainer.vue?vue&type=template&id=06858bb0&scoped=true"
import script from "./MobileFullScreenContainer.vue?vue&type=script&lang=ts"
export * from "./MobileFullScreenContainer.vue?vue&type=script&lang=ts"
import style0 from "./MobileFullScreenContainer.vue?vue&type=style&index=0&id=06858bb0&scoped=true&lang=css"
import style1 from "./MobileFullScreenContainer.vue?vue&type=style&index=1&id=06858bb0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06858bb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06858bb0')) {
      api.createRecord('06858bb0', component.options)
    } else {
      api.reload('06858bb0', component.options)
    }
    module.hot.accept("./MobileFullScreenContainer.vue?vue&type=template&id=06858bb0&scoped=true", function () {
      api.rerender('06858bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MobileFullScreenContainer.vue"
export default component.exports